import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  PDFViewer,
  Document,
  Page,
  View,
  Text,
  PDFDownloadLink,
  Image,
} from '@react-pdf/renderer';
import { Close } from '@mui/icons-material';
import PrintStampStyles from 'src/components/VehicleTrackingDetails/Tables/Pdf/PrintStampStyles';
import { getTenantLogoUrl } from 'src/redux/Actions/Tenant';

export default function PrintStamp({
  setShowMaterialIdentificationCard,
  selectedLineItem,
}) {
  const dispatch = useDispatch();

  const tenantId = useSelector(
    (state) => state.AuthReducer.userData.tenant?.id,
  );
  const tenantLogo = useSelector((state) => state.VehicleReducer.getTenantLogo);

  const tenantName = tenantLogo?.name || '';
  const tenantLogoUrl = tenantLogo?.logoImageUrl || null;
  useEffect(() => {
    if (tenantId) {
      dispatch(getTenantLogoUrl(tenantId)).catch(() => {});
    }
  }, [dispatch, tenantId]);

  const formatMaterial = (desc = '') => desc.replace(/(.{13})/g, '$1\n');
  const formatDescription = (desc = '') => desc.replace(/(.{16})/g, '$1\n');

  const materialIdentificationCard = (
    <Document>
      <Page size={[216, 288]} style={PrintStampStyles.page} key={0}>
        <View style={PrintStampStyles.borderContainer}>
          <View style={PrintStampStyles.justifyCenter}>
            <View style={PrintStampStyles.reportField}>
              {tenantLogoUrl && (
                <Image
                  src={tenantLogoUrl}
                  style={{ width: 26, height: 26, objectFit: 'contain' }}
                />
              )}
              <Text
                style={[PrintStampStyles.textBold, PrintStampStyles.textSm]}
              >
                {tenantName}
              </Text>
            </View>
          </View>

          <View style={PrintStampStyles.borderBlack} />

          <View style={PrintStampStyles.justifyCenter}>
            <View style={PrintStampStyles.reportField}>
              <Text
                style={[PrintStampStyles.textBold, PrintStampStyles.textSm]}
              >
                Material Identification Card
              </Text>
            </View>
          </View>

          <View style={PrintStampStyles.borderBlack} />

          <View style={PrintStampStyles.reportDetail}>
            <View style={PrintStampStyles.col6}>
              <View style={PrintStampStyles.innercontainer}>
                <View style={PrintStampStyles.reportDetail}>
                  <Text
                    style={[
                      PrintStampStyles.textBold,
                      PrintStampStyles.textSm,
                      { width: '35%' },
                    ]}
                  >
                    Date
                  </Text>
                  <Text style={[PrintStampStyles.textSm, { width: '5%' }]}>
                    :
                  </Text>
                  <Text style={[PrintStampStyles.textSm, { width: '60%' }]}>
                    {formatDescription(selectedLineItem?.date)}
                  </Text>
                </View>

                <View style={PrintStampStyles.reportDetail}>
                  <Text
                    style={[
                      PrintStampStyles.textBold,
                      PrintStampStyles.textSm,
                      { width: '35%' },
                    ]}
                  >
                    Material Code
                  </Text>
                  <Text style={[PrintStampStyles.textSm, { width: '5%' }]}>
                    :
                  </Text>
                  <Text style={[PrintStampStyles.textSm, { width: '60%' }]}>
                    {formatDescription(selectedLineItem?.title)}
                  </Text>
                </View>

                <View style={PrintStampStyles.reportDetail}>
                  <Text
                    style={[
                      PrintStampStyles.textBold,
                      PrintStampStyles.textSm,
                      { width: '35%' },
                    ]}
                  >
                    Description
                  </Text>
                  <Text style={[PrintStampStyles.textSm, { width: '5%' }]}>
                    :
                  </Text>
                  <Text style={[PrintStampStyles.textSm, { width: '60%' }]}>
                    {formatMaterial(selectedLineItem?.description)}
                  </Text>
                </View>

                <View style={PrintStampStyles.reportDetail}>
                  <Text
                    style={[
                      PrintStampStyles.textBold,
                      PrintStampStyles.textSm,
                      { width: '35%' },
                    ]}
                  >
                    Dept
                  </Text>
                  <Text style={[PrintStampStyles.textSm, { width: '5%' }]}>
                    :
                  </Text>
                  <Text style={[PrintStampStyles.textSm, { width: '60%' }]}>
                    {selectedLineItem?.plant}
                  </Text>
                </View>

                <View style={PrintStampStyles.reportDetail}>
                  <Text
                    style={[
                      PrintStampStyles.textBold,
                      PrintStampStyles.textSm,
                      { width: '35%' },
                    ]}
                  >
                    Quantity
                  </Text>
                  <Text style={[PrintStampStyles.textSm, { width: '5%' }]}>
                    :
                  </Text>
                  <Text style={[PrintStampStyles.textSm, { width: '60%' }]}>
                    {selectedLineItem?.actual_value}
                  </Text>
                </View>

                <View style={PrintStampStyles.reportDetail}>
                  <Text
                    style={[
                      PrintStampStyles.textBold,
                      PrintStampStyles.textSm,
                      { width: '35%' },
                    ]}
                  >
                    Remarks
                  </Text>
                  <Text style={[PrintStampStyles.textSm, { width: '5%' }]}>
                    :
                  </Text>
                  <Text style={[PrintStampStyles.textSm, { width: '60%' }]}>
                    {selectedLineItem?.remarks}
                  </Text>
                </View>
              </View>
            </View>
          </View>
        </View>
      </Page>
    </Document>
  );

  return (
    <div id="quotation-content">
      <div className="div-flex-row py-1 px-2 div-space-between">
        <button className="btn-black">
          <PDFDownloadLink
            document={materialIdentificationCard}
            fileName="temp.pdf"
            className="text-white"
          >
            {({ loading }) => (loading ? 'Loading document...' : 'Download')}
          </PDFDownloadLink>
        </button>
        <Close onClick={() => setShowMaterialIdentificationCard(false)} />
      </div>
      <PDFViewer style={{ width: '100%', height: '100vh' }}>
        {materialIdentificationCard}
      </PDFViewer>
    </div>
  );
}
